module.exports = __webpack_public_path__ + "img/image-1.dd29b6f4.webp";